// SearchInput.js (uncontrolled/local)
import React, { memo, forwardRef, useImperativeHandle, useState } from "react";
import { Input, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const SearchInput = memo(
  forwardRef(function SearchInput(
    { onSearchNow, placeholder = "ค้นหา", style, className, setSelectedRowKey },
    ref
  ) {
    const [inner, setInner] = useState("");

    useImperativeHandle(ref, () => ({
      getValue: () => inner,
      clear: () => {
        setInner("");
        onSearchNow?.("");
      },
    }), [inner, onSearchNow]);

    return (
      <Input
        placeholder={placeholder}
        value={inner}
        onChange={(e) => setInner(e.target.value)}
        onPressEnter={() => onSearchNow?.(inner)}
        autoComplete="off"
        style={style}
        className={className}
        suffix={
          <Space size={8}>
            {inner ? (
              <span
                style={{ cursor: "pointer", color: "#999" }}
                onClick={() => {
                  setInner("");
                  onSearchNow?.("");
                  setSelectedRowKey(null);
                }}
                title="ล้างคำค้นหา"
              >
                ×
              </span>
            ) : null}
            <SearchOutlined
              onClick={() => onSearchNow?.(inner)}
              style={{ cursor: "pointer", color: "#999" }}
            />
          </Space>
        }
      />
    );
  })
);

export default SearchInput;
